import {
  Box,
  Button,
  Divider,
  Drawer,
  MenuItem,
  Typography,
  useTheme,
} from '@mui/material';
import { useMutation, useQuery } from 'react-query';
import { useCallback, useState } from 'react';
import {
  organizationGet,
  organizationEdit,
  organizationDelete,
  checkVeeziAccess,
} from 'api/api';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { FastField, Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { CheckboxWithLabel, Select, TextField } from 'formik-mui';
import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { useParams } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import { useMedia } from 'react-use';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartOptions,
  TimeScale,
  ArcElement,
} from 'chart.js';
import 'chartjs-adapter-moment';
import Annotation from 'chartjs-plugin-annotation';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EventNoteIcon from '@mui/icons-material/EventNote';
import phone from 'phone';
import ct from 'countries-and-timezones';
import MuiPhoneNumber from 'material-ui-phone-number-2';
import { CircularProgressWithLabel } from 'components/CircularProgressWithLabel';
import { useProfile } from 'api/hooks';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  TimeScale,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  Annotation,
);

export const AdminOrganization = ({
  selectedOrganization,
}: {
  selectedOrganization: any;
}) => {
  const { organizationId } = useParams<{ organizationId: string }>();
  const hasPathParam = !!organizationId;
  const [dialogOpen, setDialogOpen] = useState(false);

  const [rightDrawerOpen, setRightDrawerOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertTitle, setAlertTitle] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [selected, setSelected] = useState<any | null>(null);
  const theme = useTheme();
  const isWide = useMedia('(min-width: 500px)');
  const countries = ct.getAllCountries();
  const { profile } = useProfile();
  const isSuperAdmin =
    profile?.roles?.some((role) => role.type === 'SUPER_ADMIN') ?? false;

  const handlePhoneChange = useCallback(
    (originalHandler) => (value) => {
      originalHandler({ target: { name: 'phone', value } });
    },
    [],
  );

  const pieColors = [
    theme.palette.primary.main,
    '#666',
    '#ccc',
    '#444',
    '#999',
    '#000',
    '#fff',
  ];

  const pieOptions: ChartOptions<any> = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '83%',
    color: '#fff',
    fullSize: false,
    layout: {
      autoPadding: false,
    },
    plugins: {
      legend: {
        display: false,
        position: 'right' as const,
        align: 'center',
        labels: {
          textAlign: 'left',
          color: theme.palette.text.secondary,
          boxWidth: 8,
          boxHeight: 8,
          usePointStyle: true,
        },
      },
      title: {
        display: false,
        text: 'Types',
        color: theme.palette.text.secondary,
        font: { weight: '500', size: 15 },
      },
    },
  };

  const alert = (title, message) => {
    setAlertTitle(title);
    setAlertMessage(message);
    setAlertOpen(true);
  };

  console.log('selectedOrganization', selectedOrganization);

  const {
    data: response,
    isLoading,
    error,
    refetch,
  } = useQuery(
    ['organizationGet', organizationId],
    organizationGet(Number(organizationId!)),
    {
      enabled: hasPathParam,
      refetchOnWindowFocus: false,
    },
  );
  const organization: any = response?.data;

  const dateFormat = 'YYYY-MM-DD HH:mm';

  const {
    mutateAsync,
    error: mutateError,
    data: mutateData,
    isLoading: mutateIsLoading,
  } = useMutation('organizationEdit', organizationEdit, {
    onError: (err: any) => {
      alert('Error', err.message);
    },
  });

  const formatDuration = (minutes) => {
    if (Math.floor(minutes / 60)) {
      return `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
    } else {
      return `${minutes}m`;
    }
  };

  if (!organization) {
    return (
      <Box sx={{ textAlign: 'center', mt: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <React.Fragment key="right">
        <Drawer
          anchor="right"
          open={rightDrawerOpen}
          onClose={() => {
            refetch();
            setRightDrawerOpen(false);
          }}
        >
          <Box sx={{ width: { xs: '100vw', sm: '600px' } }}>
            <Typography
              variant="h1"
              sx={{ fontSize: '1.3em', fontWeight: 500, m: '16px 24px' }}
            >
              {!!selected ? 'Edit organization' : 'Add organization'}
            </Typography>
            <Divider />
            <Box sx={{ padding: '24px' }}>
              {/*
              {!!selected && (
                <Box sx={{ mb: '16px' }}>
                  <Typography sx={{ fontWeight: 500, display: 'inline' }}>
                    User:{' '}
                  </Typography>
                  {selected?.name}
                </Box>
              )}
              */}
              {/*
              {!selected &&
                'Enter the email address of the registered user you want give permissions to the organization.'}
              */}
              <Formik
                validateOnMount
                initialValues={
                  selected || {
                    name: '',
                    legalName: '',
                    email: '',
                    phone: '',
                    country: '',
                    type: '',
                    dataSource: '',
                    veeziAccessToken: '',
                    enabled: false,
                  }
                }
                validationSchema={Yup.object().shape({
                  name: Yup.string()
                    .min(2, 'Too short')
                    .max(50, 'Too long')
                    .required('Required'),
                  legalName: Yup.string()
                    .min(2, 'Too short')
                    .max(50, 'Too long')
                    .required('Required'),
                  email: Yup.string()
                    .email('Invalid email')
                    .required('Required'),
                  phone: Yup.string()
                    .test('phone', 'Invalid phone number', (value) => {
                      console.log('phone', value);

                      if (!value) return true;
                      return phone(value).isValid;
                    })
                    .required('Required'),
                  country: Yup.string().required('Required'),
                  type: Yup.string().required('Required'),
                  dataSource: Yup.string().when('type', (type?: string) =>
                    type === 'cinema'
                      ? Yup.string().required('Required')
                      : Yup.string().notRequired(),
                  ),
                  veeziAccessToken: Yup.string().when(
                    'dataSource',
                    (dataSource, type) =>
                      ['VEEZI_US', 'VEEZI_EU'].includes(dataSource) &&
                      type === 'cinema'
                        ? Yup.string().min(20, 'Too short').required('Required')
                        : Yup.string().notRequired(),
                  ),
                })}
                onSubmit={async ({ ...values }, { setSubmitting }) => {
                  console.log(values);

                  try {
                    if (
                      values.type === 'cinema' &&
                      (values.dataSource === 'VEEZI_US' ||
                        values.dataSource === 'VEEZI_EU')
                    ) {
                      await checkVeeziAccess({
                        veeziAccessToken: values.veeziAccessToken,
                        dataSource: values.dataSource,
                      });
                    }

                    const response = await mutateAsync({ values });

                    /*
                    if (
                      !selected &&
                      !values?.enabled &&
                      response?.status === 201
                    )
                      snackbar.open({
                        type: 'success',
                        message:
                          'Thank you for your interest. We will contact you.',
                      });
                      */
                  } catch (error: any) {
                    alert(error.error, error.message);
                  }
                  refetch();
                  setSubmitting(false);
                  setRightDrawerOpen(false);
                }}
              >
                {({
                  submitForm,
                  isSubmitting,
                  values,
                  isValid,
                  handleChange,
                  errors,
                  touched,
                  handleBlur,
                }) => (
                  <Form
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '12px',
                      position: 'relative',
                    }}
                  >
                    <FastField
                      component={TextField}
                      label="Name"
                      name="name"
                      size="small"
                    />
                    <FastField
                      component={TextField}
                      label="Legal name"
                      name="legalName"
                      size="small"
                    />
                    <Box className="small-formik-select-fix">
                      <FastField
                        component={Select}
                        label="Country"
                        id="country"
                        name="country"
                        size="small"
                        required
                      >
                        {!!countries &&
                          Object.keys(countries).map((c) => (
                            <MenuItem
                              key={countries[c]?.id}
                              value={countries[c]?.name}
                            >
                              {countries[c]?.name}
                            </MenuItem>
                          ))}
                      </FastField>
                    </Box>
                    <FastField
                      component={TextField}
                      label="Contact email"
                      name="email"
                      type="email"
                      size="small"
                    />
                    <MuiPhoneNumber
                      required
                      defaultCountry={'rw'}
                      name="phone"
                      label="Contact phone"
                      variant="outlined"
                      value={values.phone}
                      onBlur={handleBlur}
                      onChange={handlePhoneChange(handleChange)}
                      error={touched.phone && !!errors.phone}
                      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      //@ts-ignore
                      helperText={(touched.phone && errors.phone) || ''}
                      className="MuiPhoneNumber"
                      InputLabelProps={{ required: false }}
                      size="small"
                    />
                    <Box className="small-formik-select-fix">
                      <FastField
                        component={Select}
                        label="Type"
                        name="type"
                        size="small"
                      >
                        <MenuItem value={'cinema'}>Cinema</MenuItem>
                        <MenuItem value={'music'}>Music</MenuItem>
                        <MenuItem value={'festival'}>Festival</MenuItem>
                        <MenuItem value={'experience'}>Experience</MenuItem>
                        <MenuItem value={'theater'}>Theater</MenuItem>
                        <MenuItem value={'kids'}>Kids</MenuItem>
                        <MenuItem value={'exhibition'}>Exhibition</MenuItem>
                        <MenuItem value={'sport'}>Sport</MenuItem>
                        <MenuItem value={'online'}>Online</MenuItem>
                        <MenuItem value={'variety'}>Variety</MenuItem>
                      </FastField>
                    </Box>
                    <Box className="small-formik-select-fix">
                      {values.type === 'cinema' && (
                        <FastField
                          component={Select}
                          label="Data source"
                          name="dataSource"
                          size="small"
                          required
                        >
                          <MenuItem value={'LOCAL'}>Local</MenuItem>
                          <MenuItem value={'VEEZI_EU'}>Veezi EU</MenuItem>
                          <MenuItem value={'VEEZI_US'}>Veezi US</MenuItem>
                        </FastField>
                      )}
                    </Box>
                    {(values.dataSource === 'VEEZI_EU' ||
                      values.dataSource === 'VEEZI_US') &&
                      values.type === 'cinema' && (
                        <FastField
                          component={TextField}
                          label="Veezi access token"
                          name="veeziAccessToken"
                          size="small"
                        />
                      )}
                    {isSuperAdmin && (
                      <Field
                        component={CheckboxWithLabel}
                        type="checkbox"
                        name="enabled"
                        Label={{ label: 'Enabled' }}
                        size="small"
                      />
                    )}
                    <Box
                      sx={{
                        textAlign: 'right',
                        margin: '8px 0 0',
                        display: 'flex',
                        flexDirection: 'row',
                      }}
                    >
                      <Button
                        color="primary"
                        disabled={isSubmitting}
                        onClick={() => {
                          setRightDrawerOpen(false);
                        }}
                        sx={{ padding: '6px 8px' }}
                      >
                        Cancel
                      </Button>
                      <Box sx={{ flex: '1 1 auto' }} />
                      {selected && (
                        <Button
                          color="primary"
                          disabled={isSubmitting}
                          onClick={() => {
                            setConfirmOpen(true);
                          }}
                          sx={{ padding: '6px 8px' }}
                        >
                          Delete
                        </Button>
                      )}
                      <Box sx={{ flex: '1 1 auto' }} />
                      <Button
                        color="primary"
                        variant="contained"
                        disabled={isSubmitting || !isValid}
                        onClick={submitForm}
                        sx={{ padding: '6px 24px' }}
                      >
                        Save
                      </Button>
                    </Box>
                  </Form>
                )}
              </Formik>
            </Box>
          </Box>
        </Drawer>
      </React.Fragment>
      <Dialog
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`${alertTitle}`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`${alertMessage}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAlertOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Deletion confirmation'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Are you sure you want to delete this? An owner of an organization cannot be deleted. This cannot be undone.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button
            onClick={async () => {
              try {
                const response = await organizationDelete(selected.id)();
                setDialogOpen(false);
                if (response) {
                  refetch();
                  setDialogOpen(false);
                  setRightDrawerOpen(false);
                }
              } catch (error: any) {
                refetch();
                setDialogOpen(false);
                setRightDrawerOpen(false);
                alert(error.error, error.message);
              }
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexGrow: 0,
          alignItems: 'center',
          gap: 1,
          mt: '-18px',
          height: '51px',
        }}
      >
        <Typography
          variant="h4"
          component="h2"
          sx={{
            fontSize: '1.25rem',
          }}
        >
          {organization.name}
        </Typography>
        <Button
          color="primary"
          onClick={() => {
            setSelected(organization);
            setRightDrawerOpen(true);
          }}
        >
          <EditIcon sx={{ ml: -0.5, mr: 0.5 }} />
          Edit
        </Button>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          flexWrap: 'wrap',
          gap: '24px 32px',
        }}
      >
        <Box>
          {isWide && (
            <Typography variant="h3" sx={{ fontSize: '1rem', mb: '16px' }}>
              Details
            </Typography>
          )}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Typography variant="body1" color="text.secondary">
              <LocationOnIcon sx={{ float: 'left', mr: '6px', opacity: 0.7 }} />
              {organization.country && <>{organization.country}</>}
            </Typography>

            <Typography variant="body1" color="text.secondary">
              <EventNoteIcon sx={{ float: 'left', mr: '6px', opacity: 0.7 }} />
              {organization.source && (
                <>
                  {(
                    organization.source.charAt(0).toUpperCase() +
                    organization.source.slice(1).toLowerCase()
                  )
                    .replace('_eu', ' EU')
                    .replace('_us', ' US')}
                </>
              )}
            </Typography>
          </Box>
        </Box>
        <Box>
          <Typography variant="h3" sx={{ fontSize: '1rem', mb: '16px' }}>
            Tickets
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              gap: { xs: '6px', sm: '24px' },
              justifyContent: { xs: 'space-between', sm: 'flex-start' },
            }}
          >
            <CircularProgressWithLabel
              label="Sold"
              realvalue={organization.usedTicketCount}
              value={organization.ticketCount}
            />
            <CircularProgressWithLabel
              label="Used"
              realvalue={organization.usedTicketCount}
              value={
                !!organization.usedTicketCount
                  ? 100 -
                    (organization.unusedTicketCount * 100) /
                      organization.ticketCount
                  : 0
              }
            />
            <CircularProgressWithLabel
              label="Unused"
              realvalue={organization.unusedTicketCount}
              value={
                !!organization.unusedTicketCount
                  ? (organization.unusedTicketCount * 100) /
                    organization.ticketCount
                  : 0
              }
            />
          </Box>
        </Box>
        {/*
        {organization.tickets.length > 0 && (
          <>
            <Box>
              <Typography variant="h3" sx={{ fontSize: '1rem', mb: '16px' }}>
                Ticket types sold
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
                <Box
                  sx={{
                    width: isWide ? '128px' : '96px',
                    height: isWide ? '128px' : '96px',
                    position: 'relative',
                  }}
                >
                  <Typography
                    sx={{
                      width: '100%',
                      height: '100%',
                      position: 'absolute',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      top: 0,
                      color: theme.palette.text.secondary,
                      pointerEvents: 'none',
                      zIndex: -1,
                    }}
                  >
                    Types
                  </Typography>
                  <Box
                    sx={{
                      zIndex: 100,
                      width: '100%',
                      height: '100%',
                    }}
                  >
                    <Doughnut
                      options={pieOptions as any}
                      data={{
                        labels: ticketTypesSold.map(
                          (ticketType: any) => ticketType.name,
                        ),
                        datasets: [
                          {
                            label: 'Ticket types',
                            data: ticketTypesSold.map(
                              (ticketType: any) => ticketType.count,
                            ),
                            backgroundColor: [
                              theme.palette.primary.main,
                              '#666',
                              '#ccc',
                              '#444',
                              '#999',
                              '#000',
                              '#fff',
                            ],
                            borderWidth: 0,
                          },
                        ],
                      }}
                    />
                  </Box>
                </Box>
                <Box>
                  <Box>
                    {!!ticketTypesSold &&
                      ticketTypesSold.map((ticketType: any, index) => (
                        <Box key={ticketType.id}>
                          <Box
                            sx={{
                              background: pieColors[index],
                              width: '0.75rem',
                              height: '0.75rem',
                              display: 'inline-block',
                              borderRadius: '100px',
                              mr: '6px',
                            }}
                          ></Box>
                          <Typography
                            color="text.secondary"
                            sx={{ display: 'inline' }}
                          >
                            {ticketType.name}: {ticketType.count}
                          </Typography>
                        </Box>
                      ))}
                  </Box>
                </Box>
              </Box>
            </Box>

            <Box sx={{ flexBasis: { xs: '100%', sm: 0 }, flexGrow: 1 }}>
              <Typography variant="h3" sx={{ fontSize: '1rem', mb: '16px' }}>
                Entry distribution
              </Typography>
              <Box sx={{ height: isWide ? '420px' : '160px' }}>
                <Line
                  options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                      legend: {
                        display: false,
                        position: 'top' as const,
                      },
                      title: {
                        display: false,
                        text: 'Entry distribution',
                        color: theme.palette.text.secondary,
                        font: { weight: '500', size: 15 },
                      },
                      annotation: {
                        annotations: myAnnotations.map((a: any) => ({
                          scaleID: 'x',
                          type: 'line',
                          value: a,
                          borderColor: theme.palette.text.secondary,
                          borderWidth: 1,
                        })),
                      },
                    },

                    scales: {
                      y: {
                        ticks: {
                          stepSize: 1,
                          autoSkip: true,
                          color: theme.palette.text.secondary,
                        },
                        grid: {
                          color: 'rgba(127 127 127/0.2)',
                        },
                      },
                      x: {
                        type: 'time',
                        ticks: {
                          maxTicksLimit: isWide ? 7 : 6,
                          autoSkip: true,
                          autoSkipPadding: 200,
                          maxRotation: 0,
                          color: theme.palette.text.secondary,
                        },
                        grid: {
                          color: 'rgba(127 127 127/0.2)',
                        },
                        time: {
                          displayFormats: {
                            millisecond: 'HH:mm',
                            second: 'HH:mm',
                          },
                        },
                      },
                    },
                  }}
                  data={data}
                />
              </Box>
            </Box>
          </>
        )}
                */}
      </Box>
    </>
  );
};
